import { FC, ReactNode } from 'react'
import { CssBaseline } from '@maas-components/core'
import {
  ThemeProvider,
  StylesProvider,
  createTheme,
  createGenerateClassName,
} from '@maas-components/styles'
import { ptBR } from '@material-ui/core/locale'
import { CSS_PREFIX } from 'common/constants/settings'

const generateClassName = createGenerateClassName({ seed: CSS_PREFIX })

export interface AppThemeProps {
  children: NonNullable<ReactNode>
}

const AppTheme: FC<AppThemeProps> = ({ children }) => {
  return (
    <StylesProvider injectFirst generateClassName={generateClassName}>
      <ThemeProvider theme={createTheme({ shellMode: 'dark' }, ptBR)}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StylesProvider>
  )
}

export default AppTheme
